import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable, throwError } from 'rxjs';
import { IOrderInquiry, IGetInvoiceBody, IInvoiceInquiry, IGetOrderInvoiceDetailsBody, IGetOrderShipmentDetailsBody, IUser, IGetOrdersInquiryBody, IGetOrdersDetailsBody, ICustomer, IGetInvoiceDetailsBody, BaseResponse, IGetInvoicePdfBody } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  //#region constructor & Members
  constructor(private httpClient: HttpClient) { }

  public get readUserObject(): IUser {
    return JSON.parse(localStorage.getItem('user')) as IUser;
  }

  //#endregion
  //#region  Order inquiry Api endPoints
  public getOrders(body: IGetOrdersInquiryBody): Observable<Array<IOrderInquiry>> {
    // const body: IGetOrdersInquiryBody = {
    //   //customerNumber: this.readUserObject.customerNumber,
    //   //Keeping hardcoded need to change
    //   customerNumber: "58089",
    //   fromDate: "120140",
    //   toDate:"121001"
    // }
    body.customerNumber = this.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.ORDER.GET_MY_ORDERS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data)
        ////tap((response) => { console.log(response); })     
      );
    //  map((item) => {
    //    item.orderDateAsDate = new Date(item.orderDateUIString);
    //    item.scheduleDateAsDate= new Date(item.scheduleDateUIString);
    //    return item;
    //  }));

  }//"3/22/2020"  2020-03-22

  //need to Format
  public getOrderDetail(body: IGetOrdersDetailsBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ORDER.GET_MY_ORDER_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getOrderInvoiceDetail(body: IGetOrderInvoiceDetailsBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ORDER.GET_ORDER_INVOICE_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getOrderShipmentDetail(body: IGetOrderShipmentDetailsBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ORDER.GET_ORDER_SHIPMENT_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }

  //change url 
  public getAddress(customerId: number): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.CUSTOMER.GET_ORDER_INVOICE_ADDRESS}/${customerId}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  //#region  Invoice inquiry Api endPoints
  public getInvoiceInquiry(body: IGetOrdersInquiryBody): Observable<Array<IInvoiceInquiry>> {
    // const body: IGetOrdersInquiryBody = {
    //   customerNumber: "58089",
    //   fromDate: "120044",
    //   toDate: "121074"
    // }
    body.customerNumber = this.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.INVOICE.GET_INVOICE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { throw err; }),
      map((items: BaseResponse) => items.data.map((item: IInvoiceInquiry) =>
        ({
          invoiceNumber: item.invoiceNumber, invoiceDate: item.invoiceDate, invoiceDateUIString: item.invoiceDateUIString, invoiceDateAsDate: new Date(item.invoiceDateUIString),
          type: item.type, jobName: item.jobName, originalAmount: item.originalAmount, amountDue: item.amountDue, checkNumber: item.checkNumber,
          marketSegment: item.marketSegment, invoiceStatus: item.invoiceStatus, billTo: item.billTo, orderBu: item.orderBu,
          orderNumber: item.orderNumber, shipTo: item.shipTo, poNumber: item.poNumber, grossAmount: item.grossAmount, openAmount: item.openAmount, taxableAmount: item.taxableAmount,
          tax: item.tax, nonTaxableAmount: item.nonTaxableAmount, kdReferenceNumber: item.kdReferenceNumber, orderType: item.orderType,
          paymentStatus: item.paymentStatus,
          dueDate: item.dueDate, dueDateUIString: item.dueDateUIString,
        dueDateAsDate: item.dueDateUIString ? new Date(item.dueDateUIString) : null
        } as IInvoiceInquiry))));
  }
  //need to Format
  public getInvoiceInquiryDetails(body: IGetInvoiceDetailsBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.INVOICE.GET_INVOICE_DETAIL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getRelatedInvoices(body: IGetInvoiceDetailsBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.INVOICE.GET_RELATED_INVOICES}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getOrderDetailsHeader(body: IGetOrdersDetailsBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ORDER.GET_ORDER_DETAILS_HEADER}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data[0])
    );
  }
  //#endregion
  //#region order inquiry clicked row data
  orderInquiryData: IOrderInquiry;
  public setOrderInquiryData(data: IOrderInquiry) {
    this.orderInquiryData = data;
  }
  public getOrderInquiryData() {
    return this.orderInquiryData;
  }
  //#endregion
  //#region invoice inquiry clicked row data
  invoiceInquiryData: IInvoiceInquiry;
  public setInvoiceInquiryData(data: IInvoiceInquiry) {
    this.invoiceInquiryData = data;
  }
  public getInvoiceInquiryData() {
    return this.invoiceInquiryData;
  }
  //endregion
  //#region Stores Invoice inquiry all grid data
  private invoiceInquiryGridData: IInvoiceInquiry[];
  public setInvoiceInquiryGridData(data: IInvoiceInquiry[]) {
    this.invoiceInquiryGridData = data;
  }
  public getInvoiceInquiryGridData(): IInvoiceInquiry[] {
    if (!this.invoiceInquiryGridData) {
      this.invoiceInquiryGridData = []
        ;
    }
    return this.invoiceInquiryGridData;
  }

  public getinvoiceNumberList(ordernumber: string): IInvoiceInquiry[] {
    if (!ordernumber) {
      return [];
    }
    const invoices = this.getInvoiceInquiryGridData().filter(r => r.orderNumber === ordernumber);
    if (!invoices) {
      return [];
    }
    return invoices;
  }

  //#endregion

  //#region Test PNC
  redirectToPNC() {
    let f = document.createElement("form");
    f.setAttribute("method", "post");
    f.setAttribute(
      "action",
      "https://pncdemo.payerexpress.net/ebp/Kawneerpay/SHO"
    ); //Your action URL
    var config = [];
    config.push({ "name": "Name", "value": "Sudipta Biswas" });
    config.push({ "name": "AccountNumber", "value": "676767" });
    config.push({ "name": "InvoiceNumber", "value": "445566" });
    config.push({ "name": "AmountDue", "value": "150.00" });
    config.push({ "name": "Email", "value": "sudipta.biswas@arconic.com" });
    config.push({ "name": "ClientID", "value": "ba073f8e-204c-4d0a-9b19-547bf50b7f43" });
    config.push({ "name": "ID", "value": "190651c6847963e15b8f14aa3fe5dd512ed2032356fb7f0a77e3e586974d6643a9141290df86c63411b032d1bafffcafe2176e2da576aa3ccb53be3b1f23d9d4" });
    //config.push({ "name": "", "value": "" });
    //create hidden input elements
    config.forEach((item) => {
      let i = document.createElement("input");
      i.type = "hidden";
      i.name = item.name;
      i.value = item.value;
      f.appendChild(i); //Add it to the form
    });

    document.body.appendChild(f);//Add the form to the body
    f.submit(); //Submit it immediately
  }
  //#endregion

  public downloadInvoice(body: IGetInvoicePdfBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.INVOICE.DOWNLOAD_INVOICE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

}
